import { accessValue } from '../../../../core/utils/accessors/access-value.js';

/**
 * Extracts a numeric value from either a number or an object with a value accessor.
 *
 * @param value - The value to extract from (number or object)
 * @param valueAccessor - The accessor string to use when value is an object
 * @returns The numeric value, or 0 if extraction fails
 */
export const getNumericValue = (
  value: number | Record<string, unknown>,
  valueAccessor?: string,
): number => {
  if (typeof value === 'number') {
    return value;
  }

  if (valueAccessor) {
    return accessValue<number>(value, valueAccessor) ?? 0;
  }

  return 0;
};
